import React from "react";
import { ReconRow } from "../types";

const RowProblemSummary: React.FC<{ row: ReconRow }> = ({ row }) => {
  const lines = row.remarkLines ?? [];

  if (lines.length > 0) {
    return (
      <>
        {lines.map((line) => (
          <span key={line.text} className={`row-remark is-${line.tone}`}>
            {line.text}
          </span>
        ))}
      </>
    );
  }

  if (!row.missedPaymentCount && row.unitDiscrepancies) {
    return (
      <span className="row-remark is-problem">
        {row.unitDiscrepancies} unit mismatch
      </span>
    );
  }

  return null;
};

export default RowProblemSummary;
